export default __webpack_public_path__ + "static/media/P314.3.6f16e5bc.mp3";